<div class="questionDistributionPattern p-4">
  <!-- ** Header -->
  <div class="questionDistributionPattern-header flex justify-between">
    <div class="questionDistributionPattern-header-title flex items-center">
      Question Distribution Pattern : {{ questionData.moduleName }}
    </div>
    <div
      *ngFor="
        let readOnlyHeaderQuestion of readOnlyHeaderData;
        let readOnlyHeaderQuestionIndex = index
      "
      class="questionDistributionPattern-header-readOnly-holder flex items-center gap-4"
    >
      <div class="questionDistributionPattern-header-readOnly-label">
        {{ readOnlyHeaderQuestion.questionType }}
      </div>
      <input
        readonly
        class="questionDistributionPattern-header-readOnly-input"
        [value]="readOnlyHeaderQuestion.numberOfQuestions"
      />
    </div>
  </div>
  <!-- ** Content -->
  <div
    [ngStyle]="{ display: areQuestionsGenerating ? 'none' : 'flex' }"
    class="questionDistributionPattern-content flex-col gap-4 p-4"
  >
    <div class="questionDistributionPattern-content-reUse-holder">
      <div class="d-flex items-center gap-2">
        <mat-slide-toggle
          class="questionDistributionPattern-content-reUse-switch"
          [ngClass]="{
            'questionDistributionPattern-content-reUse-switch-false':
              !tableContent.canRepeatQuestions
          }"
          [(ngModel)]="tableContent.canRepeatQuestions"
        >
        </mat-slide-toggle>
        <span class="questionDistributionPattern-content-reUse-switch-label"
          >Re-use Previous Test Questions</span
        >
        <mat-slide-toggle
          class="questionDistributionPattern-content-reUse-switch"
          [ngClass]="{
            'questionDistributionPattern-content-reUse-switch-false':
              !tableContent.onlyExerciseQuestions
          }"
          [(ngModel)]="tableContent.onlyExerciseQuestions"
        >
        </mat-slide-toggle>
        <span class="questionDistributionPattern-content-reUse-switch-label"
          >Use Exercise Questions</span
        >
        <mat-slide-toggle
          class="questionDistributionPattern-content-reUse-switch"
          [ngClass]="{
            'questionDistributionPattern-content-reUse-switch-false':
              !tableContent.onlyQuizQuestions
          }"
          [(ngModel)]="tableContent.onlyQuizQuestions"
        >
        </mat-slide-toggle>
        <span class="questionDistributionPattern-content-reUse-switch-label"
          >Use Quiz Questions</span
        >
      </div>
    </div>
    <div class="questionDistributionPattern-content-table w-full">
      <form [formGroup]="subTopicInfoForm">
        <table class="questionDistributionPattern-content-table">
          <thead class="questionDistributionPattern-content-table-header">
            <tr class="questionDistributionPattern-content-table-header-label">
              <th
                *ngFor="let titleInfo of tableHeadersInfo.titlesInfo"
                [attr.rowspan]="titleInfo.spanInfo.rowValue"
                [attr.colspan]="titleInfo.spanInfo.colValue"
              >
                {{ titleInfo.title }}<br />{{
                  titleInfo.extraText.length > 0 ? titleInfo.extraText : ""
                }}
              </th>
            </tr>
            <tr class="questionDistributionPattern-content-table-header-label">
              <th
                *ngFor="
                  let subtitleInfo of tableHeadersInfo.subTitlesInfo
                    .mcqSubtitles.subtitles
                "
                style="border-top: none !important"
              >
                {{ subtitleInfo }}
              </th>
              <th
                *ngFor="
                  let subtitleInfo of tableHeadersInfo.subTitlesInfo
                    .freetextSubtitles.subtitles
                "
                style="border-top: none !important"
              >
                {{ subtitleInfo }}
              </th>
            </tr>
          </thead>
          <tr
            *ngFor="
              let subTopicRow of tableContent.subTopicInfo;
              let subTopicRowIndex = index
            "
          >
            <td
              class="questionDistributionPattern-content-table-body-subTopicName"
            >
              {{ subTopicRow.subTopicName }}
            </td>
            <td>
              <input
                readonly
                class="questionDistributionPattern-content-table-body-totalMcqOrFreeText"
                [value]="subTopicRow.totalMcqFreetext"
              />
            </td>
            <td>
              <input
                class="questionDistributionPattern-content-table-body-input"
                (keyup)="printProps(subTopicRowIndex, true, 1)"
                [value]="subTopicRow.mcqs.easy"
                [formControlName]="'mcq-easy-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, true, 1).invalid
                }"
                [matTooltip]="getTooltip(subTopicRowIndex, true, 1)"
                [matTooltipDisabled]="
                  getControl(subTopicRowIndex, true, 1).valid
                "
                [matTooltipClass]="'questionDis-error-tooltip'"
              />
            </td>
            <td>
              <input
                class="questionDistributionPattern-content-table-body-input"
                (keyup)="printProps(subTopicRowIndex, true, 2)"
                [value]="subTopicRow.mcqs.medium"
                [formControlName]="'mcq-medium-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, true, 2).invalid
                }"
                [matTooltip]="getTooltip(subTopicRowIndex, true, 2)"
                [matTooltipDisabled]="
                  getControl(subTopicRowIndex, true, 2).valid
                "
                [matTooltipClass]="'questionDis-error-tooltip'"
              />
            </td>
            <td>
              <input
                class="questionDistributionPattern-content-table-body-input"
                (keyup)="printProps(subTopicRowIndex, true, 3)"
                [value]="subTopicRow.mcqs.hard"
                [formControlName]="'mcq-hard-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, true, 3).invalid
                }"
                [matTooltip]="getTooltip(subTopicRowIndex, true, 3)"
                [matTooltipDisabled]="
                  getControl(subTopicRowIndex, true, 3).valid
                "
                [matTooltipClass]="'questionDis-error-tooltip'"
              />
            </td>
            <td>
              <input
                readonly
                class="questionDistributionPattern-content-table-body-totalMcqOrFreeText"
                (keyup)="printProps(subTopicRowIndex, true, 4)"
                [value]="subTopicRow.mcqs.total"
                [formControlName]="'mcq-total-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, true, 4).invalid
                }"
              />
            </td>
            <td>
              <input
                class="questionDistributionPattern-content-table-body-input"
                (keyup)="printProps(subTopicRowIndex, false, 1)"
                [value]="subTopicRow.freetext.easy"
                [formControlName]="'freetext-easy-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, false, 1).invalid
                }"
                [matTooltip]="getTooltip(subTopicRowIndex, false, 1)"
                [matTooltipDisabled]="
                  getControl(subTopicRowIndex, false, 1).valid
                "
                [matTooltipClass]="'questionDis-error-tooltip'"
              />
            </td>
            <td>
              <input
                class="questionDistributionPattern-content-table-body-input"
                (keyup)="printProps(subTopicRowIndex, false, 2)"
                [value]="subTopicRow.freetext.medium"
                [formControlName]="'freetext-medium-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, false, 2).invalid
                }"
                [matTooltip]="getTooltip(subTopicRowIndex, false, 2)"
                [matTooltipDisabled]="
                  getControl(subTopicRowIndex, false, 2).valid
                "
                [matTooltipClass]="'questionDis-error-tooltip'"
              />
            </td>
            <td>
              <input
                class="questionDistributionPattern-content-table-body-input"
                (keyup)="printProps(subTopicRowIndex, false, 3)"
                [value]="subTopicRow.freetext.hard"
                [formControlName]="'freetext-hard-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, false, 3).invalid
                }"
                [matTooltip]="getTooltip(subTopicRowIndex, false, 3)"
                [matTooltipDisabled]="
                  getControl(subTopicRowIndex, false, 3).valid
                "
                [matTooltipClass]="'questionDis-error-tooltip'"
              />
            </td>
            <td>
              <input
                readonly
                class="questionDistributionPattern-content-table-body-totalMcqOrFreeText"
                (keyup)="printProps(subTopicRowIndex, false, 4)"
                [value]="subTopicRow.freetext.total"
                [formControlName]="'freetext-total-' + subTopicRow.subTopicId"
                [ngClass]="{
                  'questionDistributionPattern-content-table-body-input-error':
                    getControl(subTopicRowIndex, false, 4).invalid
                }"
              />
            </td>
            <!-- <td>1%</td>
          <td>6</td>
          <td>4</td>
          <td>1%</td>
          <td>6</td> -->
          </tr>
        </table>
      </form>
    </div>
    <div class="flex justify-end gap-4">
      <div class="" mat-dialog-close>
        <button class="questionDistributionPattern-content-closeBtn">
          Close
        </button>
      </div>
      <div class="" (click)="checkValidityAndCloseDialog(true)">
        <button
          class="questionDistributionPattern-content-saveBtn pointerCursor"
        >
          Generate Questions
        </button>
      </div>
    </div>
  </div>
  <div
    [ngStyle]="{ display: areQuestionsGenerating ? 'flex' : 'none' }"
    class="justify-center"
  >
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
  </div>
</div>
